import { useState } from 'react';

import { CustomAlert, CustomButton, PopupNavigation } from '../../../../../../shared/uiComponents';
import GraphBehaviorContent from './graphBehaviorContent';
import { BehaviorReductionProperties } from '../../../../../../redux/API/ClientAPIHelpers/behaviorReductionProperties';
import { Graph } from '../../../../../../shared/Assets/svgIcons';
import { useScreenWidth } from '../../../../../../shared/Helpers/hooks';

interface GraphBehaviorProps {
	allBehaviors?: BehaviorReductionProperties[];
	behaviorId: string;
	currentIndex?: number;

	data: BehaviorReductionProperties;
	onlyIcon?: boolean;
}

const GraphBehavior = ({ data, onlyIcon, allBehaviors, currentIndex = 0 }: GraphBehaviorProps) => {
	const [open, setOpen] = useState<boolean>(false);
	const [activeIndex, setActiveIndex] = useState<number>(currentIndex);

	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	const hasNavigation = allBehaviors && allBehaviors.length > 1;
	const currentBehavior = hasNavigation ? allBehaviors[activeIndex] : data;

	const handlePrevious = () => {
		if (activeIndex > 0) {
			setActiveIndex(activeIndex - 1);
		}
	};

	const handleNext = () => {
		if (allBehaviors && activeIndex < allBehaviors.length - 1) {
			setActiveIndex(activeIndex + 1);
		}
	};

	const handleClose = () => {
		setOpen(false);
		// Reset to initial index when closing
		setActiveIndex(currentIndex);
	};

	return (
		<>
			<CustomButton
				title={onlyIcon || isMobile ? '' : 'View Graph'}
				onClick={() => setOpen(true)}
				startIcon={<Graph />}
				className="graphBehaviorButtonContainer"
			/>
			<CustomAlert
				title={currentBehavior.name}
				open={open}
				onClose={handleClose}
				Content={() => (
					<>
						<GraphBehaviorContent data={currentBehavior} behaviorId={currentBehavior.id} />
						{hasNavigation && (
							<PopupNavigation
								currentIndex={activeIndex}
								totalCount={allBehaviors.length}
								onPrevious={handlePrevious}
								onNext={handleNext}
							/>
						)}
					</>
				)}
			/>
		</>
	);
};

export default GraphBehavior;
